// src/components/NewsFeed.js
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import NewsItem from "./NewsItem";

const FeedContainer = styled.div`
  flex: 1;
  padding: 2rem;
`;

const FeedTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

const FeedTitle = styled.h1`
  color: #0AFF50;
`;

const RefreshButton = styled.button`
  background-color: #0F0F0F;
  color: #00FF41;
  border: 1px solid #00FF41;
  padding: 0.4rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #131313;
  }
`;

// Hard-coded articles with preset AI status
const hardCodedArticles = [
  {
    source: { id: null, name: "BBC News" },
    author: null,
    title: "Trump to be sentenced in hush money case on 10 January - BBC.com",
    description: "The US president-elect dismisses the case as \"nothing but a rigged charade\".",
    url: "https://www.bbc.com/news/articles/c390mrmxndyo",
    urlToImage:
      "https://ichef.bbci.co.uk/news/1024/branded_news/fa77/live/2490ccf0-ca18-11ef-9ca4-e15068af8864.jpg",
    publishedAt: "2025-01-04T11:53:22Z",
    content:
      "A judge has ordered that Donald Trump will be sentenced on 10 January ... [+3397 chars]",
    status: "Partially True",
  },
  {
    source: { id: "associated-press", name: "Associated Press" },
    author: "TARA COPP",
    title:
      "Soldier who died by suicide in Las Vegas told ex-girlfriend of pain and exhaustion after Afghanistan - The Associated Press",
    description:
      "The highly decorated Special Forces soldier ... were key symptoms of trauma…",
    url: "https://apnews.com/article/trump-hotel-fire-soldier-brain-trauma-afghanistan-4c5a20b500bc2131a7ef324878938034",
    urlToImage:
      "https://dims.apnews.com/dims4/default/a304221/2147483647/strip/true/crop/4500x2531+0+234/resize/1440x810!/quality/90/?url=https%3A%2F%2Fassets.apnews.com%2Fee%2F8a%2Fb359e9ffd59d238c0f4439160ab9%2F88453fa044504e47b6fb963a1e3f6d37",
    publishedAt: "2025-01-04T11:51:00Z",
    content:
      "WASHINGTON (AP) The highly decorated Special Forces soldier ... [+4940 chars]",
    status: "True",
  },
  {
    source: { id: null, name: "BBC News" },
    author: null,
    title: "Tomiko Itooka: World's oldest person dies aged 116 - BBC.com",
    description:
      "Ms Itooka lived through two world wars and was credited with a sprightly spirit all her life.",
    url: "https://www.bbc.com/news/articles/c9830vpp2p0o",
    urlToImage:
      "https://ichef.bbci.co.uk/news/1024/branded_news/7650/live/0bc88a70-ca93-11ef-9fd6-0be88a764111.jpg",
    publishedAt: "2025-01-04T10:54:14Z",
    content:
      "A Japanese woman, recognised as the world's oldest person ... [+1669 chars]",
    status: "True",
  },
  {
    source: { id: "cbs-news", name: "CBS News" },
    author: "Allie Weintraub, Caitlin Yilek",
    title:
      "Biden awards Presidential Medal of Freedom to Hillary Clinton, Michael J. Fox, Lionel Messi and more - CBS News",
    description:
      "The nation's highest civilian honor will be presented to 19 people later Saturday.",
    url: "https://www.cbsnews.com/news/biden-presidential-medal-of-freedom-hillary-clinton-bono-lionel-messi/",
    urlToImage:
      "https://assets1.cbsnewsstatic.com/hub/i/r/2025/01/04/ff3b801e-22c8-47e7-bb3f-188b2044c055/thumbnail/1200x630/e473e991f60a48c1d3420ab57c7965b7/gettyimages-621743972.jpg?v=fa9977353833f46f40b07abcd9d5240b",
    publishedAt: "2025-01-04T10:00:03Z",
    content:
      "Washington — President Biden is awarding the Presidential Medal of Freedom ... [+1824 chars]",
    status: "True",
  },
  {
    source: { id: null, name: "KOMU 8" },
    author: "Matt Beckwith, Beth Finello, Kesley Kobielusz & Patrick Herion",
    title: "Storm Mode: Tracking a winter storm across Missouri - KOMU 8",
    description:
      "A winter storm will impact Mid-Missouri Saturday night through Monday morning with a bitter blast on the way.",
    url: "https://www.komu.com/weather/storm-mode-tracking-a-winter-storm-across-missouri/article_87ff90a2-c70f-11ef-a000-cf925767a042.html",
    urlToImage:
      "https://bloximages.newyork1.vip.townnews.com/komu.com/content/tncms/assets/v3/editorial/8/7f/87ff90a2-c70f-11ef-a000-cf925767a042/67774dea6fa85.preview.png?crop=1920%2C1008%2C0%2C35&resize=1200%2C630&order=crop%2Cresize",
    publishedAt: "2025-01-04T10:00:00Z",
    content:
      "Good morning and happy Saturday! The big story, of course, is the winter storm ... [+2921 chars]",
    status: "True",
  },
  {
    source: { id: "cnn", name: "CNN" },
    author: "Jamie Barton, Jacob Lev",
    title:
      "Miami Heat suspend Jimmy Butler for seven games, will consider trade offers - CNN",
    description:
      "Following Jimmy Butler’s postgame comments ... indicated he would like to be traded",
    url: "https://www.cnn.com/2025/01/03/sport/jimmy-butler-suspension-trade-miami-heat-spt/index.html",
    urlToImage:
      "https://media.cnn.com/api/v1/images/stellar/prod/2025-01-03t042632z-284149113-mt1usatoday25104002-rtrmadp-3-nba-indiana-pacers-at-miami-heat.JPG?c=16x9&q=w_800,c_fill",
    publishedAt: "2025-01-04T09:23:00Z",
    content:
      "Following Jimmy Butlers postgame comments where he indicated he would like ... [+3826 chars]",
    status: "True",
  },
  {
    source: { id: null, name: "Yahoo Entertainment" },
    author: "Jack Baer",
    title: "Watch what Victor Wembanyama just did to Nikola Jokić - Yahoo Sports",
    description: "Are we ready to call Victor Wembanyama a top 5 player?",
    url: "https://sports.yahoo.com/watch-what-victor-wembanyama-just-did-to-nikola-jokic-051922836.html",
    urlToImage:
      "https://s.yimg.com/ny/api/res/1.2/2uKb3KDwvkMMPc_VzvkKUA--/YXBwaWQ9aGlnaGxhbmRlcjt3PTEyMDA7aD04MDA-/https://s.yimg.com/os/creatr-uploaded-images/2025-01/0429fcf0-ca5b-11ef-bbdf-9147a7d12a84",
    publishedAt: "2025-01-04T05:20:12Z",
    content:
      "What are NBA players supposed to do against Victor Wembanyama? ... [+2788 chars]",
    status: "Partially True",
  },
  {
    source: { id: "the-washington-post", name: "The Washington Post" },
    author: "Jason Samenow",
    title:
      "Threat of major winter storm grows for D.C. area Sunday night into Monday - The Washington Post",
    description:
      "More than 4 inches of snow is probable for the region; some areas could see an icy mix.",
    url: "https://www.washingtonpost.com/weather/2025/01/03/dc-region-snow-winter-storm-forecast-ice/",
    urlToImage:
      "https://www.washingtonpost.com/wp-apps/imrs.php?src=https://arc-anglerfish-washpost-prod-washpost.s3.amazonaws.com/public/4QIQGJVT65IT2ETBRWCGGVMF4Y.JPG&w=1440",
    publishedAt: "2025-01-04T03:12:54Z",
    content:
      "The D.C. area faces the potential for its biggest snow since January 2022 ... [+4560 chars]",
    status: "Partially True",
  },
  {
    source: { id: "bloomberg", name: "Bloomberg" },
    author: "Bob Van Voris, Michelle Kaske",
    title:
      "NYC Congestion Pricing Cleared by Judge for Sunday Launch - Bloomberg",
    description:
      "New York’s controversial plan to charge drivers ... was cleared by a federal judge.",
    url: "https://www.bloomberg.com/news/articles/2025-01-04/nyc-congestion-pricing-cleared-by-judge-for-sunday-launch",
    urlToImage:
      "https://assets.bwbx.io/images/users/iqjWHBFdfxIU/iZaBefXO3IvY/v1/1200x800.jpg",
    publishedAt: "2025-01-04T02:46:00Z",
    content:
      "New Yorks controversial plan to charge drivers ... was cleared ... [+284 chars]",
    status: "True",
  },
  {
    source: { id: null, name: "Space.com" },
    author: "Brett Tingley",
    title:
      "SpaceX launches 1st Falcon 9 rocket of 2025, sends Thuraya 4 communications satellite to orbit (video) - Space.com",
    description:
      "This was the 20th flight and recovery for this Falcon 9 first stage booster...",
    url: "https://www.space.com/space-exploration/launches-spacecraft/spacex-launches-1st-falcon-9-rocket-of-2025",
    urlToImage:
      "https://cdn.mos.cms.futurecdn.net/6dEQD8kozATFYG4cKoXfGk-1200-80.jpg",
    publishedAt: "2025-01-04T02:14:09Z",
    content:
      "SpaceX launched its first Falcon 9 rocket of 2025 tonight, in what should be another busy year ... [+2507 chars]",
    status: "True",
  },
  {
    source: { id: null, name: "Hindustan Times" },
    author: "Aditi Srivastava",
    title:
      "Angelina Jolie walks away $80 million richer as Brad Pitt feels 'weight lifted' after eight-year divorce war - Hindustan Times",
    description:
      "Despite a prenuptial agreement, the sale of their co-owned Château Miraval estate significantly boosts Jolie's finances...",
    url: "https://www.hindustantimes.com/entertainment/hollywood/angelina-jolie-walks-away-80-million-richer-as-brad-pitt-feels-weight-lifted-after-eight-year-divorce-war-101735952064245.html",
    urlToImage:
      "https://www.hindustantimes.com/ht-img/img/2025/01/04/1600x900/FILES-US-ENTERTAINMENT-FILM-JOLIE-PITT-0_1735656278784_1735954866282.jpg",
    publishedAt: "2025-01-04T01:44:41Z",
    content:
      "Angelina Jolie is closing a chapter of her life and walking away $80 million richer ... [+2756 chars]",
    status: "Partially True",
  },
  {
    source: { id: null, name: "9to5google.com" },
    author: "Andrew Romero",
    title:
      "Hisense’s new L9Q short-throw projector with Google TV hits a blistering 5,000 lumens - 9to5Google",
    description:
      "Hisense has a track record of releasing impressive short-throw projector options that offer a well-executed Google TV experience...",
    url: "http://9to5google.com/2025/01/03/hisenses-new-l9q-short-throw-projector-with-google-tv-hits-a-blistering-5000-lumens/",
    urlToImage:
      "https://i0.wp.com/9to5google.com/wp-content/uploads/sites/4/2025/01/Hisense-L9Q-projhector-with-Google-TV.jpg?resize=1200%2C628&quality=82&strip=all&ssl=1",
    publishedAt: "2025-01-04T00:59:00Z",
    content:
      "Hisense has a track record of releasing impressive short-throw projector options ... [+2508 chars]",
    status: "True",
  },
  {
    source: { id: "abc-news", name: "ABC News" },
    author: "The Associated Press",
    title:
      "An Arizona prisoner is asking to be executed sooner than the state wants - ABC News",
    description:
      "An Arizona death row prisoner ... schedule his execution earlier than authorities were aiming for",
    url: "https://abcnews.go.com/US/wireStory/arizona-prisoner-executed-sooner-state-117319820",
    urlToImage:
      "https://i.abcnewsfe.com/a/25c710e0-7f7d-4e70-b3e3-7cbe503a3c02/wirestory_c7359f2d5a5912debc238caff7c49529_16x9.jpg?w=1600",
    publishedAt: "2025-01-04T00:49:36Z",
    content:
      "PHOENIX -- An Arizona death row prisoner asked the states highest court ... [+2013 chars]",
    status: "Partially True",
  },
  {
    source: { id: null, name: "Wrestling Inc." },
    author: "Daisy Ruth",
    title:
      "Rumored 'Last Minute Rewrites' On Tonight's WWE SmackDown Could Result In Title Change - Wrestling Inc.",
    description:
      "Rumored last minute re-writes to \"WWE SmackDown\" on Friday could result in a possible title change...",
    url: "https://www.wrestlinginc.com/1752541/rumored-last-minute-rewrites-tonight-wwe-smackdown-result-title-change/",
    urlToImage:
      "https://www.wrestlinginc.com/img/gallery/rumored-last-minute-rewrites-on-tonights-wwe-smackdown-could-result-in-title-change/l-intro-1735950781.jpg",
    publishedAt: "2025-01-04T00:42:00Z",
    content:
      "\"WWE SmackDown\" moves to three hours on the USA Network ... with a potential title change ... [+1402 chars]",
    status: "False",
  },
  {
    source: { id: "the-washington-post", name: "The Washington Post" },
    author: "Fenit Nirappil, Vivian Ho",
    title:
      "Surgeon general calls for alcohol to carry cancer warning - The Washington Post",
    description:
      "Alcohol is the third leading preventable cause of cancer in the United States, Vivek Murthy said...",
    url: "https://www.washingtonpost.com/health/2025/01/03/alcohol-cancer-warning-surgeon-general/",
    urlToImage:
      "https://www.washingtonpost.com/wp-apps/imrs.php?src=https://arc-anglerfish-washpost-prod-washpost.s3.amazonaws.com/public/Z4BS7PP7B6JSBSC4XOAL56SEUU.jpg&w=1440",
    publishedAt: "2025-01-03T23:46:59Z",
    content:
      "Health warning labels on alcohol should be updated to include a cancer risk warning ... [+6113 chars]",
    status: "True",
  },
  {
    source: { id: null, name: "Turn to 10" },
    author: "TEMI-TOPE ADELEYE, NBC 10 NEWS",
    title:
      "Department of Health talks rise in respiratory illnesses, expects increase in number - Turn to 10",
    description: "Respiratory illnesses are on the rise, but there are ways to prevent the spread.",
    url: "https://turnto10.com/news/local/department-of-health-rise-respiratory-illnesses-expected-increase-number-norovirus-rsv-flu-covid-sick-rhode-island-january-3-2025",
    urlToImage:
      "https://turnto10.com/resources/media/274e76ec-b797-423f-a652-1fa7b1e47425-large16x9_6PPRIDOHOVERBUDGET.transfer_frame_5884.jpeg?1670887030851",
    publishedAt: "2025-01-03T23:36:25Z",
    content:
      "Respiratory illnesses are on the rise ... Rhode Island's Department of Health has noticed ... [+2505 chars]",
    status: "Partially True",
  },
  {
    source: { id: null, name: "SportsLine" },
    author: "SportsLine",
    title:
      "$1 million parlay: Get SportsLine's top Week 18 NFL picks for shot at gargantuan return - SportsLine",
    description: null,
    url: "https://www.sportsline.com/insiders/1-million-parlay-get-sportslines-top-week-18-nfl-picks-for-shot-at-gargantuan-return/",
    urlToImage: null,
    publishedAt: "2025-01-03T22:41:00Z",
    content: null,
    status: "False",
  },
  {
    source: { id: "axios", name: "Axios" },
    author: "Andrew Solender",
    title: "Mike Johnson reelected as speaker after brief revolt - Axios",
    description:
      "Johnson's prospects hung by a thread for 45 minutes after several GOP lawmakers defected.",
    url: "https://www.axios.com/2025/01/03/mike-johnson-reelected-house-speaker-first-ballot",
    urlToImage:
      "https://images.axios.com/eUk6xu4qCq1f90Qad9SmFhS37NQ=/0x134:7486x4345/1366x768/2025/01/03/1735864104526.jpg",
    publishedAt: "2025-01-03T22:39:42Z",
    content:
      "Rep. Mike Johnson (R-La.) was reelected as the speaker of the House on Friday ... [+2905 chars]",
    status: "True",
  },
  {
    source: { id: null, name: "Yahoo Entertainment" },
    author: "Nicholas Tan",
    title: "What Is HMPV? New Virus Outbreak in China Explained - Yahoo! Voices",
    description:
      "Is there a risk of a pandemic? The post What Is HMPV? New Virus Outbreak in China Explained appeared first on Mandatory.",
    url: "https://www.yahoo.com/news/hmpv-virus-outbreak-china-explained-222804823.html",
    urlToImage:
      "https://media.zenfs.com/en/mandatory_995/c7c16c6bd8a02ecc8f0d457c769ab947",
    publishedAt: "2025-01-03T22:28:04Z",
    content:
      "Yahoo is using AI to generate takeaways from this article. ... [+2089 chars]",
    status: "False",
  },
  {
    source: { id: "espn", name: "ESPN" },
    author: "Doug Greenberg",
    title: "Ravens listed as 20-point favorites vs. Browns - ESPN",
    description:
      "The Ravens are listed as 20-point favorites over the Browns on Saturday...",
    url: "https://www.espn.com/nfl/story/_/id/43274720/ravens-listed-20-point-favorites-vs-browns",
    urlToImage:
      "https://a4.espncdn.com/combiner/i?img=%2Fphoto%2F2024%2F1224%2Fr1431639_1296x729_16%2D9.jpg",
    publishedAt: "2025-01-03T21:07:00Z",
    content:
      "With Baltimore needing a victory to win the AFC North ... the Ravens are a 20-point favorite ... [+2037 chars]",
    status: "True",
  },
];

const NewsFeed = ({ currentFilter }) => {
  const [news, setNews] = useState([]);

  // We won't do any API fetch. We'll just set the articles from our hard-coded data.
  useEffect(() => {
    // On component mount, load our local array into state
    setNews(hardCodedArticles);
  }, []);

  // Refresh does nothing now
  const handleRefresh = () => {
    // No-op
  };

  // Filter the news based on currentFilter
  const filteredNews = news.filter((item) => {
    if (currentFilter === "All") return true;
    return item.status === currentFilter;
  });

  return (
    <FeedContainer>
      <FeedTitleWrapper>
        <FeedTitle>Latest News</FeedTitle>
        <RefreshButton onClick={handleRefresh}>Refresh</RefreshButton>
      </FeedTitleWrapper>

      {filteredNews.map((item) => (
        <NewsItem
          key={item.url} // using url as a unique key
          title={item.title}
          content={item.description || "No description available."}
          status={item.status}
          source={item.url}
        />
      ))}

      {filteredNews.length === 0 && (
        <p style={{ color: "#b3ffce" }}>No articles match this filter.</p>
      )}
    </FeedContainer>
  );
};

export default NewsFeed;
